import { render, staticRenderFns } from "./OSvg.vue?vue&type=template&id=a872cace&"
import script from "./OSvg.vue?vue&type=script&lang=js&"
export * from "./OSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports